import HeroImage from 'v1/assets/icons/zenhr/home/hero-image.webp'
import EmployeeDirectoryImage from 'v1/assets/icons/zenhr/home/employee-directory-image.webp'
import LeaveManagementImage from 'v1/assets/icons/zenhr/home/leave-management-image.webp'
import AttendanceManagementImage from 'v1/assets/icons/zenhr/home/attendance-management-image.webp'
import DocumentManagementImage from 'v1/assets/icons/zenhr/home/document-management-image.webp'

import PerformanceCycleImage from 'v1/assets/icons/zenhr/home/performance-cycle-image.webp'
import GoalSettingImage from 'v1/assets/icons/zenhr/home/goal-setting-image.webp'
import O1MeetingsImage from 'v1/assets/icons/zenhr/home/1-o-1-meetings-image.webp'
import AiDrivenImage from 'v1/assets/icons/zenhr/home/ai-driven-insight-image.webp'

import StreamlinedAccessmage from 'v1/assets/icons/zenhr/home/streamlined-access-image.webp'
import RealTimeUpdatesImage from 'v1/assets/icons/zenhr/home/real-time-updates-image.webp'
import ConversationalAiImage from 'v1/assets/icons/zenhr/home/conversational-ai-image.webp'

import OnboardingAndOffboardingImage from 'v1/assets/icons/zenhr/home/automated-onbaording-offboarding-image.webp'
import DataDrivenInsightImage from 'v1/assets/icons/zenhr/home/data-driven-insight-image.webp'
import CentralizedHRDataImage from 'v1/assets/icons/zenhr/home/centralized-hr-data-image.webp'

import userTieIcon from 'v1/assets/icons/zenhr/home/user-tie.svg'
import userGroupIcon from 'v1/assets/icons/zenhr/home/users-group-2.svg'
import passportIcon from 'v1/assets/icons/zenhr/home/passport-2.svg'
import creditCardIcon from 'v1/assets/icons/zenhr/home/creditcard-flash.svg'
import commentsIcon from 'v1/assets/icons/zenhr/home/comments.svg'

import onboardingImage from 'v1/assets/icons/zenhr/home/onboarding-image.webp'
import transitionImage from 'v1/assets/icons/zenhr/home/transitions-image.webp'
import offboardingImage from 'v1/assets/icons/zenhr/home/offboarding-image.webp'

import onboardingMobileImage from 'v1/assets/icons/zenhr/home/onboarding-mobile-image.webp'
import transitionMobileImage from 'v1/assets/icons/zenhr/home/transitions-mobile-image.webp'
import offboardingMobileImage from 'v1/assets/icons/zenhr/home/offboarding-mobile-image.webp'

export const heroData = {
  title: 'Transformative HR Solutions for HR and Operations Leaders',
  subTitle: `Streamline and elevate your HR processes with ZenAdmin's comprehensive HR suite.`,
  paragraph:
    'Empowering HR and Operations Leaders to optimize employee experiences and drive strategic value',
  image: HeroImage,
  btnText: 'Start Your Free Trial',
}
export const mainData = {
  title: 'ZenAdmin HR Products & Services',
  paragraph:
    'ZenAdmin offers a complete suite of tools to help you centralize HR data, automate workflows, and provide an exceptional employee experience, all within a unified platform.',
}
export const zenHRISData = {
  title: 'Human Resource Information System (HRIS)',
  desc: 'Our HRIS ensures all employee information is at your fingertips. Designed for secure data storage and easy access, it simplifies HR management for large and small teams alike.',
  slides: [
    {
      btnDetails: {
        title: 'Employee Directory',
        desc: 'Seamlessly manage organizational hierarchy and employee details, helping leaders access crucial information in seconds.',
      },
      slideDetails: {
        img: {
          src: EmployeeDirectoryImage,
          height: 640,
          width: 634,
        },
      },
    },
    {
      btnDetails: {
        title: 'Leave Management',
        desc: ' Automated leave requests, approvals, and balance tracking ensure your team’s time-off process is smooth and transparent.',
      },
      slideDetails: {
        img: {
          src: LeaveManagementImage,
          height: 640,
          width: 634,
        },
      },
    },
    {
      btnDetails: {
        title: 'Attendance Management',
        desc: 'Customizable attendance tracking systems meet your specific business needs and can integrate with biometric systems.',
      },
      slideDetails: {
        img: {
          src: AttendanceManagementImage,
          height: 640,
          width: 634,
        },
      },
    },
    {
      btnDetails: {
        title: 'Document Management',
        desc: 'Securely manage and retrieve important employee documents with a click, helping HR teams save up to 40% of time spent on manual document retrieval.',
      },
      slideDetails: {
        img: {
          src: DocumentManagementImage,
          height: 640,
          width: 634,
        },
      },
    },
  ],
}

export const performanceManagementData = {
  title: 'Performance Management',
  desc: 'Motivate and empower your teams with structured and supportive performance management.',
  slides: [
    {
      btnDetails: {
        title: 'Performance Cycle',
        desc: 'Built-in workflows for reviews and feedback foster a performance-driven culture.',
      },
      slideDetails: {
        img: {
          src: PerformanceCycleImage,
          height: 640,
          width: 634,
        },
      },
    },
    {
      btnDetails: {
        title: 'Goal Setting',
        desc: 'Align individual objectives with company goals, promoting clarity and accountability.',
      },
      slideDetails: {
        img: {
          src: GoalSettingImage,
          height: 640,
          width: 634,
        },
      },
    },
    {
      btnDetails: {
        title: '1-o-1 Meetings',
        desc: 'Facilitate productive, meaningful conversations between managers and team members, enhancing engagement and retention.',
      },
      slideDetails: {
        img: {
          src: O1MeetingsImage,
          height: 640,
          width: 634,
        },
      },
    },
    {
      btnDetails: {
        title: 'AI-Driven Insights',
        desc: 'Leverage AI to personalize goal setting, analyze feedback, and provide actionable insights that drive growth.',
      },
      slideDetails: {
        img: {
          src: AiDrivenImage,
          height: 640,
          width: 634,
        },
      },
    },
  ],
}

export const employeeExperienceData = {
  title: 'Employee Experience (ZenEx)',
  desc: 'The Zen Experience Portal (ZenEx) enables employees to manage essential HR functions—like Policies, SOPs, Reimbursements, Attendance, and Leave Applications—directly within their preferred platforms, such as Microsoft Teams or Slack, without the need for separate logins.',
  slides: [
    {
      btnDetails: {
        title: 'Streamlined Access',
        desc: 'Employees can quickly find what they need directly from their workspace, eliminating time wasted on switching between tools.',
      },
      slideDetails: {
        img: {
          src: StreamlinedAccessmage,
          height: 640,
          width: 634,
        },
      },
    },
    {
      btnDetails: {
        title: 'Real-Time Updates',
        desc: 'ZenEx keeps employees informed and engaged, providing instant access to HR resources, policy updates, and more.',
      },
      slideDetails: {
        img: {
          src: RealTimeUpdatesImage,
          height: 640,
          width: 634,
        },
      },
    },
    {
      btnDetails: {
        title: 'Conversational AI',
        desc: 'Transform your Employee Self-Service experience with AI-driven, conversational interfaces on Slack & MS Teams that allow employees to resolve HR, Finance, and IT issues on-the-go.',
      },
      slideDetails: {
        img: {
          src: ConversationalAiImage,
          height: 640,
          width: 634,
        },
      },
    },
  ],
}

export const automationAndAiData = {
  title: 'Powered by Automation & AI',
  paragraph:
    'ZenAdmin goes beyond traditional HR by leveraging AI and automation to eliminate repetitive tasks, providing you with time to focus on strategic initiatives. Here’s how our platform drives value.',
  tabs: [
    {
      key: 'automatedOnboardingOffboarding',
      title: 'Automated Onboarding & Offboarding',
      paragraph:
        'Fully automated workflows ensure smooth employee transitions, saving HR teams 2-4 hours per onboarding/ offboarding and enhancing security by automatically revoking access.',
      image: OnboardingAndOffboardingImage,
    },
    {
      key: 'dataDrivenInsights',
      title: 'Data-Driven Insights',
      paragraph:
        'Our AI-powered analytics deliver real-time insights into employee engagement, performance, and turnover risks, helping reduce turnover by up to 15-20% with proactive strategies.',
      image: DataDrivenInsightImage,
    },
    {
      key: 'centralizedHrData',
      title: 'Centralized HR Data',
      paragraph:
        'ZenAdmin centralizes employee data into a single, secure platform, improving accuracy and compliance. With a 360-degree view of your workforce, HR leaders can make informed decisions efficiently.',
      image: CentralizedHRDataImage,
    },
  ],
}

export const hrServices = {
  title: 'HR Services',
  cards: [
    {
      icon: userTieIcon,
      title: 'Professional Employer Organization (PEO)',
      paragraph:
        'Leave HR administration, payroll, and compliance to us. Focus on your core business while we handle the details.',
    },
    {
      icon: userGroupIcon,
      title: 'Employer of Record (EOR)',
      paragraph:
        'Global expansion made simple with our EOR services. We handle compliance, payroll, and legal responsibilities for your international teams.',
    },
    {
      icon: passportIcon,
      title: 'Contractor Management',
      paragraph:
        'Unified processes for managing contractors with accurate payments, compliance checks, and easy onboarding/offboarding.',
    },
    {
      icon: creditCardIcon,
      title: 'Payroll as a Service',
      paragraph:
        'Ensure seamless payroll processing with comprehensive tax filings and full regulatory compliance. Our clients report 95% faster payroll processing and zero compliance issues.',
    },
    {
      icon: commentsIcon,
      title: 'HR Concierge',
      paragraph:
        'Give your team access to dedicated support for HR inquiries, benefits, policies, and more.',
    },
  ],
}

export const onboardingAndOffboardingData = {
  tabs: [
    {
      key: 'Onboarding ',
      title: 'Accelerate onboarding and save time',
      paragraph:
        'ZenHR ensures that the offboarding process is thorough, compliant, and secure, minimizing risks and disruptions. Automated offboarding processes lead to smoother employee exits, protecting company data and ensuring compliance with regulations, thereby reducing the risk of post-departure issues.',
      btnText: 'Onboarding ',
      image: onboardingImage,
      mobileImage: onboardingMobileImage,
      list: [
        'Generate and send the offer letter.',
        'Generate and send the offer letter.',
        'Assign essential training and set up access to necessary tools.',
      ],
    },
    {
      key: 'Transitions ',
      title: 'Make employee changes within seconds',
      paragraph:
        'ZenHR Cloud automates the complexities of employee role changes, such as promotions and department transfers, ensuring that every transition is handled efficiently. This automation reduces administrative delays, keeps employees engaged, and maintains organizational continuity, contributing to better workforce management.',
      btnText: 'Transitions ',
      image: transitionImage,
      mobileImage: transitionMobileImage,
      list: [
        'Update job title and payroll details.',
        'Modify organizational chart.',
        'Assign new role-specific policies.',
      ],
    },
    {
      key: 'Offboarding ',
      title: 'Smooth and Secure Employee Exits',
      paragraph:
        'ZenHR Cloud ensures that the offboarding process is thorough, compliant, and secure, minimizing risks and disruptions. Automated offboarding processes lead to smoother employee exits, protecting company data and ensuring compliance with regulations, thereby reducing the risk of post-departure issues.',
      btnText: 'Offboarding ',
      image: offboardingImage,
      mobileImage: offboardingMobileImage,
      list: [
        'Prepare separation agreements.',
        'Terminate company benefits',
        'Deactivate access to company systems and software.',
      ],
    },
  ],
}
